import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import SpecialtiesRoutes from "./SpecialtiesRoutes";
import DrugInteractionsRoutes from "./DrugInteractionsRoutes";
import AtoZBrowse from "./AtoZBrowse";
import MerativeAssistant from "../components/MerativeAssistant";
import BaseTemplate from "../templates/BaseTemplate";
import ChemoRegimenFilterBase from "../templates/ChemoRegimensFilter/BaseTemplate";
import NotFound from "../components/NotFound";
import DrugsAZ from "./DrugsAZ";

export default function Routes() {
  return (
    <>
      <Switch>
        <Route path="/browse/specialties" component={SpecialtiesRoutes} />
        <Route
          path="/browse/patient-information"
          component={SpecialtiesRoutes}
        />
        <Route
          path="/browse/drug-interactions"
          component={DrugInteractionsRoutes}
        />
        <Route
          path="/browse/:slug(drug-pediatric|drug-neonatal)"
          component={AtoZBrowse}
        />
        <Route path="/browse/iv-compatibility" component={MerativeAssistant} />
        <Route
          path="/browse/:slug(signs-and-symptoms|cultural-overviews)"
          component={BaseTemplate}
        />
        <Route
          path="/browse/:slug(leadership)"
          exact={true}
          component={BaseTemplate}
        />
        <Route
          path="/browse/:type(tests-and-labs)/:slug(imaging-tests|lab-tests|assessments|diagnostic-procedures)"
          component={BaseTemplate}
        />
        <Route
          path="/browse/:type(patient-handouts)/:slug(diseases-and-conditions|procedures-and-tests|health-and-wellness|discharge-instructions)"
          component={BaseTemplate}
        />
        <Route
          path="/browse/:type(interventions)/:slug(care-interventions|treatment-modalities)"
          component={BaseTemplate}
        />
        <Route
          path="/browse/:type(skills)/:slug(nursing-skills|allied-health-skills|clinical-assistant-skills|cultural-care-skills|patient-instruction-skills)"
          component={BaseTemplate}
        />
        <Redirect
          exact
          from="/browse/chemo-regimens"
          to="/browse/chemo-regimens/diseases"
        />
        <Route
          path="/browse/:type(chemo-regimens)/:slug(diseases|agents)"
          component={BaseTemplate}
        />
        <Route
          path="/browse/:type(chemo-regimens)/:slug(bydisease|byagent)"
          component={ChemoRegimenFilterBase}
        />
        <Route
          path="/browse/:type(leadership)/:slug(case-management|leadership-development|professional-development-and-education|finance-and-budget|national-patient-safety-goals|quality-compliance-and-patient-satisfaction|healthcare-costs|preceptorship|staffing-and-scheduling|human-resources|process-theory-and-models-of-care|workplace)"
          component={BaseTemplate}
        />
        <Route
          path="/browse/:slug(diseases-and-conditions)"
          component={BaseTemplate}
        />
        <Route
          path="/browse/:slug(drug-monograph|drug-monographs)"
          component={DrugsAZ}
        />
        <Route component={NotFound} />
      </Switch>
    </>
  );
}
